module.exports = __webpack_public_path__ + "static/img/award5_a.4751104.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/index/award5_a.png
// module id = P1wu
// module chunks = 7